<template lang="pug">
  //- TODO
  //- remove the following temporary stuff
  //- .temporary(v-if="!isAuthenticated")
    .alert.error
      p Sie sind nicht angemeldet. Momentan ist es nicht möglich als Gast fortzufahren.
  //- keep this
  //- (v-else)
  .checkout-stepper
    Spinner(v-if="saving" :size="16" :thickness="3")
    .alert.success(v-if="success")
      p Vielen Dank für Ihre Bestellung
    .alert.warning(v-else-if="!articlePivots.length")
      p Sie haben keine Artikel im Warenkorb
    template(v-else)
      Tabs(:steps="checkout.steps" :position="position")
      validation-observer(v-slot="{ invalid }" ref="form")
        form.content.py-4(v-if="step" @submit.prevent.stop="submit")
          transition(name="slide-fade" mode="out-in")
            CartStep.step(
              v-if="step.key === 'cart'"
              :pagination="pagination"
              @change-page="refetch"
              @update-cart="refetch"
            )
            //- :form="checkout.form.account"
            AccountStep.step(
              v-if="step.key === 'account'"
              @block="blocked = true"
              @unblock="blocked = false"
            )
            //- :form="checkout.form.shipping"
            ShippingStep.step(
              v-if="step.key === 'shipping'"
            )
            //- :form="checkout.form"
            PaymentStep.step(
              v-if="step.key === 'payment'"
            )
        .pagination-container
          button.prev.button(v-if="position > 1" @click="prev")
            font-awesome-icon(icon="arrow-left")
            span.ml-2 {{ prevLabel }}
          .prev.placeholder(v-else)
          button.next.button(v-if="position < checkout.steps.length" :disabled="blocked || pagination.loading || position === 1 && invalid" @click="next")
            span.mr-2 {{ nextLabel }}
            font-awesome-icon(icon="arrow-right")
          //- button.purchase.button(v-else-if="simplePayment" :disabled="invalid" @click="submit") Kostenpflichtig Bestellen
</template>

<script>
// import Vue from 'vue'
// import uniqid from 'uniqid';
import { mapGetters, mapMutations, mapActions } from 'vuex';

import { get, cloneDeep } from '@/helpers';

import countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';
countries.registerLocale(de);

import { ValidationObserver, ValidationProvider } from 'vee-validate';

import Tabs from '@/extensions/shop/components/CheckoutStepper/Tabs';
import CartStep from '@/extensions/shop/components/CheckoutStepper/Steps/CartStep';
import AccountStep from '@/extensions/shop/components/CheckoutStepper/Steps/AccountStep';
import ShippingStep from '@/extensions/shop/components/CheckoutStepper/Steps/ShippingStep';
import PaymentStep from '@/extensions/shop/components/CheckoutStepper/Steps/PaymentStep';

export default {
    name: 'CheckoutStepper',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // success: false,
        // steps: [
        //   {
        //     key: 'cart',
        //     position: 1,
        //     label: 'Warenkorb',
        //     icon: 'shopping-cart'
        //   },
        //   {
        //     key: 'account',
        //     position: 2,
        //     label: 'Benutzerdaten',
        //     icon: 'user'
        //   },
        //   {
        //     key: 'shipping',
        //     position: 3,
        //     label: 'Versand',
        //     icon: 'dolly-flatbed'
        //   },
        //   {
        //     key: 'payment',
        //     position: 4,
        //     label: 'Bestellen',
        //     icon: 'money-bill'
        //   }
        // ],
        // position: 4, // TODO: change back to `1`
        // initialised: false,
        // wait: false, // prevent submitting while transition animation leads to valid
        // saving: false,
        blocked: false,
        pagination: {
            loading: false,
            pageInfo: {
                currentPage: 1,
                lastPage: 1,
                perPage: 6,
                total: 0
            },
            items: []
        }
        // form: {
        //   cart: {
        //     // needed for guest purchaser
        //     articlePivots: [],
        //     qty: 0,
        //     sum: 0,
        //     tax: 0
        //   },
        //   account: {
        //     // will get a purchaser
        //     id: undefined, // member id: undefined -> guest
        //     gender: 'M',
        //     first_name: '',
        //     last_name: '',
        //     phone: '',
        //     email: '',
        //     billing_address: {
        //       // default_billing address data from member
        //       id: undefined,
        //       gender: 'M',
        //       first_name: '',
        //       last_name: '',
        //       company: '',
        //       street: '',
        //       street_addition: '',
        //       zipcode: '',
        //       city: '',
        //       country: '', // ISO-2 code
        //       type: 'billing',
        //       latitude: undefined,
        //       longitude: undefined
        //     }
        //   },
        //   shipping: {
        //     id: undefined,
        //     gender: 'M',
        //     first_name: '',
        //     last_name: '',
        //     company: '',
        //     street: '',
        //     street_addition: '',
        //     zipcode: '',
        //     city: '',
        //     country: '', // ISO-2 code
        //     type: 'billing',
        //     latitude: undefined,
        //     longitude: undefined
        //   },
        //   payment: {
        //     id: undefined // payment method
        //   }
        // }
    }),
    components: {
        Tabs,
        CartStep,
        AccountStep,
        ShippingStep,
        PaymentStep,
        ValidationObserver,
        ValidationProvider
    },
    watch: {
        isAuthenticated(value) {
            if (value === false && this.position > 2) this.position = 2;
        }
    },
    computed: {
        valid() {
            let valid = true;
            if (this.pagination.loading) valid = false;
            return valid;
        },
        step() {
            let step;
            if (this.position > 0) {
                step = this.checkout.steps.find(el => el.position === this.position);
            }
            return step;
        },
        prevLabel() {
            let label;
            if (this.position > 1) {
                const step = this.checkout.steps.find(el => el.position === this.position - 1);
                label = step.label;
            }
            return label;
        },
        nextLabel() {
            let label;
            if (this.position < this.checkout.steps.length) {
                const step = this.checkout.steps.find(el => el.position === this.position + 1);
                label = step.label;
            }
            return label;
        },
        simplePayment() {
            const payment = get(this.checkout.form.payment, 'service');
            return ['paypal', 'stripe'].includes(payment) === false;
        },
        articlePivots() {
            return get(this.cart, 'articlePivots', []);
        },
        saving: {
            get() {
                return this.checkout.saving;
            },
            set(value) {
                this.setSaving(value);
            }
        },
        success: {
            get() {
                return this.checkout.success;
            },
            set(value) {
                this.setSuccess(value);
            }
        },
        position: {
            get() {
                return this.checkout.position;
            },
            set(value) {
                this.setPosition(value);
            }
        },
        ...mapGetters({
            cms: 'CMS',
            member: 'auth/member',
            isAuthenticated: 'auth/isAuthenticated',
            customer: 'shop/customer',
            cart: 'shop/cart',
            checkout: 'shop/checkout',
            addressOptions: 'shop/addressOptions',
            token: 'auth/token',
            defaultTax: 'shop/defaultTax',
            defaultCustomerGroup: 'shop/defaultCustomerGroup'
        })
    },
    methods: {
        async next() {
            const valid = await this.$refs.form.validate();
            if (valid) {
                this.wait = true;
                ++this.position;

                setTimeout(() => {
                    this.wait = false;
                }, 400);
            }
        },
        prev() {
            --this.position;
        },
        async submit() {
            // if (this.wait) {
            //   const errorMessage = {
            //     id: uniqid(),
            //     // title: 'Lucky Look',
            //     // text: 'Schneller als der eigene Schatten',
            //     title: 'Sie sind zu schnell',
            //     text: 'Versuchen Sie es nochmal.',
            //     type: 'warning',
            //     autoclose: 4000
            //   };
            //   this.addMessage(errorMessage);
            // } else {
            //   const valid = await this.$refs.form.validate();
            //   console.log('submit', valid);
            //   if (!valid) {
            //     const errorMessage = {
            //       id: uniqid(),
            //       title: 'Ungültige Bestellung',
            //       text: 'Korrigieren Sie Ihre Angaben.',
            //       type: 'warning',
            //       autoclose: 4000
            //     };
            //     this.addMessage(errorMessage);
            //   } else {
            //     if (this.cart.articlePivots && this.cart.articlePivots.length) {
            //       this.saving = true;
            //       let items = [];
            //       this.cart.articlePivots.forEach(pivot => {
            //         const item = {
            //           qty: pivot.qty,
            //           article: {
            //             id: pivot.article.id
            //           },
            //           propertyValues: pivot.propertyValues.map(pv => ({ id: pv.id }))
            //         };
            //         items.push(item);
            //       });
            //       const data = {
            //         shop: {
            //           id: parseInt(this.cms.shop.id)
            //         },
            //         purchaser: {
            //           customer: {
            //             id: this.customer.id,
            //             member: {
            //               id: this.member.id
            //             }
            //           }
            //         },
            //         items,
            //         paymentMethod: {
            //           id: this.checkout.form.payment.id
            //         }
            //       };
            //       this.createPurchase(data)
            //         .then(() => {
            //           this.success = true;
            //           this.addMessage({
            //             id: uniqid(),
            //             title: 'Erfolg',
            //             text: 'Ihre Bestellung wurde erfolgreich übermittelt.',
            //             type: 'success',
            //             autoclose: 4000
            //           });
            //         })
            //         .finally(() => (this.saving = false));
            //     }
            //   }
            // }
        },
        refetch(currentPage = 1) {
            const shop = this.cms.shop.id;
            const articleIDs = this.articlePivots.map(pivot => pivot.article.id);

            const payload = {
                pageInfo: {
                    currentPage,
                    perPage: this.pagination.pageInfo.perPage
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'articles',
                        in: articleIDs
                    }
                ]
            };

            if (articleIDs && articleIDs.length) {
                this.$set(this.pagination, 'loading', true);

                let actions = [];
                const fetchProducts = this.fetchProducts(payload).then(pagination => {
                    this.pagination = cloneDeep(pagination);

                    // const el = document.querySelector('.section.checkout')
                    // const container = document.querySelector('.checkout-page-columns > .column.left > .ps')
                    // if (container) {
                    //   if (! el) container.scrollTop = 0
                    //   else el.scrollIntoView()
                    // }

                    // this.products = products
                });
                actions.push(fetchProducts);

                // init cart only once
                // if (!this.checkout.initialised) {
                const initCart = this.initCart(this.member);
                actions.push(initCart);
                // }

                return Promise.all(actions).finally(() => {
                    this.$set(this.pagination, 'loading', false);
                    this.setInitialized(true);
                });
            }
        },
        ...mapMutations({
            setSaving: 'shop/setCheckoutSaving',
            setSuccess: 'shop/setCheckoutSuccess',
            setPosition: 'shop/setCheckoutPosition',
            setInitialized: 'shop/setCheckoutInitialised'
            // setFormAccount: 'shop/setCheckoutFormAccount',
        }),
        ...mapActions({
            addMessage: 'message/add',
            submitCheckoutForm: 'shop/submitCheckoutForm',
            // createPurchase: 'shop/createPurchase',
            fetchProducts: 'shop/fetchProductsWithArticlesPaginated',
            initCheckout: 'shop/initCheckoutForm',
            initCart: 'shop/initCart'
        })
    },
    mounted() {
        this.refetch();
        this.initCheckout();
    }
};
</script>

<style lang="sass" scoped>
.pagination-container
  @apply flex justify-between
.content
  @apply flex justify-center items-center
  position: relative
  min-height: 120px
  @screen md
    min-height: 280px
  .cart-step
    width: 100%
.spinner-container
  background: rgba(255, 255, 255, .5)
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%

.checkout-stepper
  @apply relative mb-6
  &::v-deep
    .panel-heading
      @apply mb-2 text-xl text-gray-500
      @screen sm
        padding-left: 5rem
    .panel
      @apply bg-gray-100
      width: 100%
      @screen md
        @apply mx-auto
        width: 580px
        max-width: 100%
      .double-field,
      .trible-field
        @screen sm
          @apply flex
          --gap: 1rem
          margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap))
          width: calc(100% + var(--gap))
          .field
            flex-basis: 50%
            flex-grow: 1
            margin: var(--gap) 0 0 var(--gap)
        .field fieldset.form-field
          margin-bottom: 1rem
        &:last-child
          .field
            &:last-of-type
              fieldset
                margin-bottom: 0
            fieldset
              @screen sm
                margin-bottom: 0
      .box .form-field:last-child
        margin-bottom: 0

      .preview
        @apply grid
        grid-gap: 1rem
        text-decoration: none
        @screen sm
          grid-template-rows: auto
          grid-template-columns: 3rem auto
        &.member
          @apply mb-4
        &:hover,
        &:focus
          .icon
            .default-icon
              display: none
            .edit-icon
              display: block
        & > .icon
          @apply flex items-center
          min-height: 3rem
          width: 3rem
          svg
            width: 3rem
            height: 3rem
          .edit-icon
            display: none
            height: 2.8rem
        .data
          @apply flex flex-col justify-center
        .details
          grid-column: 1/3
          z-index: 0
        .label
          @apply font-bold


      .field-preview + .field-preview
        @apply mt-3

  .spinner-container
    z-index: 1
</style>
